import { requestNotificationToken } from "./request-notification-token";

export async function requestNotificationPermission() {
  //requesting permission using Notification API
  const permission = await Notification.requestPermission();

  if (permission === "granted") {
    return requestNotificationToken();
  } else if (permission === "denied") {
    //notifications are blocked
    throw new Error("User blocked the notification");
  }
}
